import {i18n} from '@/plugins/i18n'

export const walletChargePeriod = {
    DAILY: 24,
    EVERY_48: 48,
    EVERY_72: 72,
    WEEKLY: 168,
}

export const walletChargePeriodStr = {
    DAILY: i18n.t('wallets.charge_period.daily'),
    EVERY_48: i18n.t('wallets.charge_period.every_48'),
    EVERY_72: i18n.t('wallets.charge_period.every_72'),
    WEEKLY: i18n.t('wallets.charge_period.weekly'),

    get(type) {
        let period_str = null;

        Object.keys(walletChargePeriod).forEach(item => {
            if (walletChargePeriod[item] === type) {
                period_str = walletChargePeriodStr[item];
            }
        });

        return period_str;
    }
}